import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { content } from '@/content/sr';

const ProductsPreview = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section className="section-padding bg-neutral-50" data-testid="products-preview-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="caption text-brand-accent block mb-4"
          >
            {content.products.caption}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-4xl md:text-5xl font-light text-brand-primary mb-4"
          >
            {content.products.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-neutral-500 max-w-xl mx-auto"
          >
            {content.products.subtitle}
          </motion.p>
        </div>

        {/* Products Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {content.products.categories.map((category) => (
            <motion.div key={category.id} variants={itemVariants}>
              <Link
                to={`/shop?category=${category.id}`}
                className="product-card group block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2"
                data-testid={`product-card-${category.id}`}
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-700 
                             group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/90 via-brand-primary/20 to-transparent 
                              opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-8 translate-y-4 group-hover:translate-y-0 
                              opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <h3 className="font-heading text-2xl text-white mb-2">{category.name}</h3>
                  <p className="text-neutral-200 text-sm mb-4">{category.description}</p>
                  <span className="inline-flex items-center gap-2 text-brand-accent text-sm font-bold 
                             group-hover:text-white transition-colors">
                    Saznaj više <FaArrowRight size={12} />
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-white group-hover:opacity-0 transition-opacity duration-300">
                  <h3 className="font-heading text-xl text-brand-primary">{category.name}</h3>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link 
            to="/proizvodi" 
            className="btn-primary inline-flex items-center gap-3"
            data-testid="products-cta"
          >
            {content.products.cta} <FaArrowRight size={14} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductsPreview;
